T.GameSetup = Class(
	/**
	 * @lends {T.GameSetup#}
	 */
	{
		animations: {
			"setup": {
				steps: 3,
				file: '/assets/animations/game-setup/setup/setup.json',
				timers: {
					1: 0,
					2: 96,
					3: 192,
					4: 285
				}
			},
			"virtual": {
				steps: 4,
				file: '/assets/animations/game-setup/virtual/ez-play.json',
				timers: {
					1: 0,
					2: 120,
					3: 240,
					4: 360
				}
			}
		},

		__construct( type, animation, custom ) {
			this.type = type;
			this.animation = animation;
			if( animation === 'custom' ) {
				this.animations['custom'] = custom;
			}

			let gameSetupSwitch = mkE({
				tag: 'div',
				className: 'game-setup-switch'
			});
			for( let i = 1; i <= this.animations[animation].steps; i++ ) {
				if( i > 1 ) {
					mkE({
						tag: 'div',
						className: 'game-setup-steps-separator'
					}).append(gameSetupSwitch);
				}
				mkE({
					tag: 'a',
					className: `game-setup-switch-${i} ${i === 1 ? 'active' : ''}`,
					onclick: D.closure(this, this._goStep, i, true),
					text: i
				}).append(gameSetupSwitch);
			}

			this.node = mkE({
				tag: 'div',
				className: 'game-setup-main container',
				els: [
					{
						tag: 'div',
						className: 'bs-row',
						els: [
							{
								tag: 'div',
								className: 'col-12 col-md-4',
								els: [
									{
										tag: 'div',
										className: 'game-setup-image-container',
										els: [
											this._lottieContainer = mkE({
												tag: 'div',
												className: 'game-setup-image'
											})
										]
									}
								]
							},
							{
								tag: 'div',
								className: 'col-12 col-md-8',
								els: [
									gameSetupSwitch,
									{
										tag: 'div',
										className: 'game-setup-steps',
										els: [
											{
												tag: 'div',
												className: 'game-setup-step',
												els: [
													this._stepsTitle = mkE({
														tag: 'h3',
														className: 'active',
														text: D.Lang.get(`game-setup.${this.type}.steps.${1}.caption`)
													}),
													this._stepsText = formatTextNode(mkE({
														tag: 'p',
														text: D.Lang.get(`game-setup.${this.type}.steps.${1}.description`)
													}))
												]
											}
										]
									}
								]
							}
						]
					}
				]
			});
		},

		_goStep( step, switchAnimation ) {
			if( this.currentStep === step ) {
				return;
			}
			removeClassName(this.node, `step-${this.currentStep}`);
			removeClassName(document.querySelector('.game-setup-switch-' + this.currentStep), 'active');
			this.currentStep = step;
			setNodeText(this._stepsTitle, D.Lang.get(`game-setup.${this.type}.steps.${this.currentStep}.caption`));
			setNodeText(this._stepsText, D.Lang.get(`game-setup.${this.type}.steps.${this.currentStep}.description`));
			formatTextNode(this._stepsText);
			addClassName(this.node, `step-${this.currentStep}`);
			addClassName(document.querySelector('.game-setup-switch-' + this.currentStep), 'active');
			if( switchAnimation === true && this._animation ) {
				let timers = this.animations[this.animation].timers;
				this._animation.goToAndPlay(timers[step], true);
			}
		},

		onShow() {
			this.currentStep = 1;
			this.steps = this.animations[this.animation].steps;
			addClassName(this.node, `step-${this.currentStep}`);
			if( this.animations[this.animation].static ) {
				return;
			}
			D.lottie({
				container: this._lottieContainer,
				renderer: 'svg',
				loop: false,
				autoplay: true,
				path: this.animations[this.animation].file
			}).then(animation => {
				this._animation = animation;
				this._animation.addEventListener("enterFrame", event => {
					let timers = this.animations[this.animation].timers;
					for( let i = 1, l = Object.keys(timers).length; i < l; i++ ) {
						if( Math.floor(event.currentTime) === timers[i + 1] - 1 ) {
							this._animation.pause();
							return;
						}
					}
				});
			});
		},

		onLeave() {
			if( this._animation ) {
				this._animation.destroy();
			}
		}
	},
	mkE.Base
)